import {IMAGES_URL} from "modules/constants";

export const MOMENT_IMAGE_URL = `${IMAGES_URL}image/BUDWEISERPOTMs/moments/`;
export const COMPETITION_IMAGE_URL = `${IMAGES_URL}image/BUDWEISERPOTMs/competitions/`;
export const THEOPLAYER_LICENSE: string = process.env.REACT_APP_THEOPLAYER_LICENSE || "";

export const helpLinks = [
	{
		url: "/help/guidelines",
		key: "help.fifa.how_to",
	},
	{
		url: "/help/faqs",
		key: "help.fifa.faqs",
	},
	{
		url: "/help/contact",
		key: "help.fifa.contact_us",
	},
	{
		url: "/help/terms",
		key: "help.fifa.terms",
	},
	{
		url: "/help/privacy",
		key: "help.fifa.privacy",
	},
	{
		url: "/help/prizes",
		key: "help.fifa.prizes",
	},
];

export const COUNTRIES_WITHOUT_BEER = [43834, 43888, 43872, 43835, 43817];

export const VOTE_END = 88;
export const EXTRA_VOTE_END = 120;

export const MS_IN_SECOND = 1000;
export const SEC_IN_MINUTE = 60;
export const MIN_IN_HOUR = 60;
export const HRS_IN_DAY = 24;
export const SEC_IN_HOUR = MIN_IN_HOUR * SEC_IN_MINUTE;
export const SEC_IN_DAY = HRS_IN_DAY * SEC_IN_HOUR;
